export default "__VITE_ASSET__Ms37qkSu__"